import React, { useEffect } from 'react';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import EmailMarketingComponent from 'components/EmailMarketing/EmailMarketingComponent';

export const EmailMarketing: React.FC = () => {
    useEffect(() => {
        document.title = 'Email Marketing - Organizations';
    }, []);

    return (
        <DashboardLayout>
            <EmailMarketingComponent />
        </DashboardLayout>
    );
};

export default EmailMarketing;
